import PropTypes from "prop-types";

import Container from "components/grid/container";
import NewsCard from "components/cards/news-card";
import { useEnvContext } from "next-runtime-env";

import styles from "./styles.module.css";

const NewsList = ({ data }) => {
  const { NEXT_PUBLIC_EJ_APP_CANONICAL_HOST } = useEnvContext();

  const safeCanonicalHost = NEXT_PUBLIC_EJ_APP_CANONICAL_HOST || "";

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.header}>
          <h2 className={styles.title}>Emlak Haberleri</h2>
          <a href={`${safeCanonicalHost}/haber/haber/`} className={styles.link}>
            Tüm Haberler
          </a>
        </div>
        <ul className={styles.list}>
          {data?.map((item) => (
            <li key={item?.slug}>
              <NewsCard data={item} />
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
};

NewsList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      slug: PropTypes.string,
    })
  ),
};

export default NewsList;
